<template>
  <DatatableReportV3
    id="members-by-address-table"
    title="By Address"
    download-url="/reports/members_by_address"
    :source="source"
    :config="config"
    :filters="filters"
  />
</template>

<script>
import Badge from "@/components/Badge.vue";
import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";
import TagList from "@/Tags/TagList.vue";

export default {
  components: {
    DatatableReportV3
  },
  props: {
    source: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      config: {
        order: [[0, "asc"]],
        columns: [
          { data: "customer" },
          { data: "service_address", title: "Service Address" },
          { data: "zipcode", title: "Zip Code" },
          { data: "location_name", title: "Location Name" },
          { data: "program", filterName: "program", searchable: false },
          {
            data: "membership_status",
            title: "Member Status",
            filterName: "membership_status",
            searchable: false
          },
          {
            data: "days_to_renewal",
            title: "Days to Renewal",
            searchable: false
          },
          {
            data: "available_services",
            title: "Available Services",
            filterName: "available_services",
            orderable: false,
            searchable: false
          },
          {
            data: "renewal_type",
            title: "Renewal Type",
            filterName: "renewal_type",
            orderable: false,
            searchable: false
          },
          { data: "since", filterName: "starts_on", searchable: false },
          {
            data: "next_billing_date",
            title: "Next Billing Date",
            filterName: "renews_at",
            searchable: false
          },
          { data: "ends_on", title: "Ends On", searchable: false },
          { data: "customer_email", title: "Email" },
          { data: "customer_phone", title: "Phone" },
          { data: "tags", title: "Tags", orderable: false, searchable: false }
        ],
        vueComponents: [
          {
            rootId: "tag-list-vue",
            component: TagList
          },
          {
            rootId: "badge-vue",
            component: Badge
          }
        ]
      }
    };
  },
  mounted() {
    this.$store.dispatch("addBreadcrumb", { label: "By Address" });
  }
};
</script>

<style lang="scss" scoped></style>
